import template from "./../templates/clickZonesComponent.dust";
import { requiredArg } from "./../utilities/utils";

export default class ClickZonesComponent {
  constructor(
    appState,
    page,
    index,
    options,
    DOMContainer = requiredArg("DOMContainer"),
    prepend = false
  ) {
    this._appState = appState;
    this._page = page;
    this._index = index;
    this._options = options;
    this._DOMContainer = DOMContainer;
    this._prepend = prepend;
  }

  render() {
    const context = {};
    context.clickZone = this._createClickZones();
    Dust.render(template, context, (err, result) => {
      if (this._prepend) {
        const div = document.createElement("div");
        div.innerHTML = result;
        div.classList.add("swiper-slide-page-click-container");
        this._DOMContainer.append(div);
      } else {
        this._DOMContainer.innerHTML = result;
      }
    });
  }

  ////////////

  _createClickZones() {
    return [...this._page.content]
      .sort((a, b) => {
        return a.Width * a.Height < b.Width * b.Height ? 1 : -1;
      })
      .map((content, index) => {
        return this._createClickZone(content, index);
      });
  }

  _createClickZone(content, index) {
    const left = (content.StartX / this._options.page_width_reference) * 100;
    const top = (content.StartY / this._options.page_height_reference) * 100;
    let width = (content.Width / this._options.page_width_reference) * 100;
    let height = (content.Height / this._options.page_height_reference) * 100;

    //cut of zones that are > 100%
    if (width > 100) {
      width = 100;
    }
    if (height > 100) {
      height = 100;
    }

    const clickZone = [];
    clickZone.left = left;
    clickZone.top = top;
    clickZone.width = width;
    clickZone.height = height;
    clickZone.articleNumber = index;
    clickZone.contentID = content.ContentID;
    clickZone.index = this._index;
    clickZone.pageID = this._page.PublicationPageID;

    if (content.contentItemContent().extraType) {
      clickZone.extra = true;
      clickZone.extraType = content.contentItemContent().extraType;
      clickZone.extraNumber = content.contentItemContent().extras.length;

      if (
        clickZone.extraNumber === 1 &&
        clickZone.extraType === ("url" || "video")
      ) {
        clickZone.extraUrl =
          content.contentItemContent().extras[0].ContentItemUrl;
      }

      if (this._options.extraLinkDirectAccess) {
        if (
          clickZone.extraNumber === 1 &&
          clickZone.extraType === ("url" || "video") &&
          content.contentItemContent().images.length <= 0 &&
          content.contentItemContent().article.HtmlText === "" &&
          content.contentItemContent().article.Introduction === ""
        ) {
          clickZone.hasOnlyLinkOrVideo = true;
        }
      }

      if (
        content.contentItemContent().extraPlacement &&
        content.contentItemContent().extraPlacement.PublicationPageID ==
          this._page.PublicationPageID
      ) {
        const { extraPlacement } = content.contentItemContent();
        const readerDimentions = this._appState.isDesktop
          ? $("#turn-reader").turn("options")
          : {
              width: $(".swiper-slide-active .swiper-slide-container").width(),
              height: $(
                ".swiper-slide-active .swiper-slide-container"
              ).height(),
            };
        const pageWidth = readerDimentions.width / 2;
        const pageHeight = readerDimentions.height;

        const ratioWidth = this._options.page_width_reference / pageWidth;
        const ratioHeight = this._options.page_height_reference / pageHeight;

        let xOffset = 0;
        let yOffset = 0;

        switch (this._options.enrichment_placement_horizontal) {
          case "right":
            xOffset = extraPlacement.Width;
            break;
          case "center":
            xOffset = extraPlacement.Width / 2;
            break;
          default:
            break;
        }

        switch (this._options.enrichment_placement_vertical) {
          case "bottom":
            yOffset = extraPlacement.Height;
            break;
          case "center":
            yOffset = extraPlacement.Width / 2;
            break;
          default:
            break;
        }

        const enrichmentX = (extraPlacement.StartX + xOffset) / ratioWidth;
        const enrichmentY = (extraPlacement.StartY + yOffset) / ratioHeight;

        const enrichmentXPercent = (enrichmentX / pageWidth) * 100;
        const enrichmentYPercent = (enrichmentY / pageHeight) * 100;

        clickZone.extraPosition = {
          top: `${enrichmentYPercent}%`,
          left: `${enrichmentXPercent}%`,
          corner: `${this._options.enrichment_placement_horizontal}-${this._options.enrichment_placement_vertical}`,
        };
      }
    }
    return clickZone;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/clickZonesComponent.js